import { combineEpics } from 'redux-observable';
import { onItemClick } from './click/index.tsx';
import { fetchInitialBoardsEpic } from './fetch-initial-boards/index.tsx';
import { loadMoreEpic } from './load-more/index.tsx';
import { retryEpic } from './retry/index.tsx';
import { searchBoardsEpic } from './search-boards/index.tsx';

export default combineEpics(
	fetchInitialBoardsEpic,
	searchBoardsEpic,
	onItemClick,
	loadMoreEpic,
	retryEpic,
);
